import { Injectable } from '@angular/core';
import { SynchronizationsService } from '@proxy/services';
import { firstValueFrom } from 'rxjs';
import { SyncConsts } from '../../AppConsts';
import { LocalDb } from '../local-db';
import { LocalDbConsts } from '../local-db-consts';
import { MachineSync } from '../objects/machine-sync';

@Injectable({ providedIn: 'root' })
export class MachineRepository {
  constructor(
    private readonly _db: LocalDb,
    private readonly _syncService: SynchronizationsService
  ) {}

  async refreshMachines(): Promise<void> {
    const table = this._db.machines;

    let skip = 0;
    let total = 0;

    let machines: MachineSync[] = [];

    do {
      const result = await firstValueFrom(
        this._syncService.getMachines({
          skipCount: skip,
          maxResultCount: SyncConsts.PageSize,
        })
      );

      total = result.pagedResult.totalCount;

      machines = machines.concat(
        result.pagedResult.items.map(dto => ({
          id: dto.id,
          name: dto.name ?? '',
        }))
      );

      skip += SyncConsts.PageSize;
    } while (skip < total);

    await this._db.transaction(LocalDbConsts.localDbReadWriteTransaction, table, async () => {
      await table.clear();
      await table.bulkAdd(machines);
    });
  }

  getById(id: number): Promise<MachineSync> {
    return this._db.machines.get(id);
  }
}
